import { Component, OnInit, ViewChild, OnDestroy, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { UserProfileDetailsComponent } from './user-profile-details/user-profile-details.component';
import {
  IAccessDetail,
  ICardCredentials,
  FilterUserParameter,
  IShareAccess,
  IUserActivity,
  IuserGroup,
  IUserGroupDetails,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription, forkJoin, of } from 'rxjs';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import {
  Utility,
  activityParseDate,
  convertParseDateTime,
  extractDateTimeFromDateString,
} from 'src/app/shared/utils/utility.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { AccountSettingsService } from 'src/app/shared-layout/header/account-settings/account-setting.service';
import { IFilterCriteria } from 'src/app/shared-layout/header/account-settings/account-setting-interfaces';
import { ConfirmRemoveDialogComponent } from 'src/app/shared-layout/Components/confirm-remove-dialog/confirm-remove-dialog.component';
import { PhysicalCredentialRemovedComponent } from 'src/app/shared-layout/Components/physical-credential-removed/physical-credential-removed.component';
import { UserProfileGroupsComponent } from './user-profile-groups/user-profile-groups.component';
import { AccessLevelRequest } from 'src/app/shared/constants/request-mapping';
import { UserManagementService } from '../user-management.service';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import {
  Activities,
  IActivityEvents,
} from 'src/app/shared-layout/Components/activity/activity.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit, OnDestroy {
  @ViewChild(UserProfileDetailsComponent) profileDetailsRef:
    | UserProfileDetailsComponent
    | undefined;

  @ViewChild(UserProfileGroupsComponent) profileGroupsRef:
    | UserProfileGroupsComponent
    | undefined;

  formGroup!: FormGroup;
  subscription: Subscription | undefined;
  ownSubscription: Subscription | undefined;
  readonly LANG_CONST = LANG_CONST;
  stepper = 1;
  selectedGroup!: IuserGroup;
  selectedAccess!: any;
  SuccessMessage = '';
  phoneNumber!: string;
  firstName!: string;
  lastName!: string;
  email!: string;
  code: string = '';
  phone: string = '';
  sharedData: any;
  profileDetails!: IUserProfile;
  ownProfile!: boolean;
  userId!: string;
  userCredentials: ICardCredentials[] = [];
  userActivities: IUserActivity[] = [];
  userActivitiesNew: Activities = { events: [] };
  userActivity!: any;
  userGroup: undefined;
  skipStepUserType!: boolean;
  skipStepBuilding!: boolean;
  addGroupFlag: boolean = false;
  deleteGroupFlag: boolean = false;
  profileSelectedGroup: any;
  accesspointCount: any;
  lockCount: any;
  totalAccessCount: any;
  siteTimeZone: string | undefined;
  parentRouteParams!: any | undefined;
  accessIds: string[] = [];
  commonAccessControl!: boolean;
  groupTypeName!: string;
  userGroupId!: string;
  flowType: string = '';
  userNotHaveExistingGroup!: boolean;
  pageSize = 40;

  userGroupList: IUserGroupDetails[] = [];
  userListsubscription: Subscription | undefined;
  /**
   * @description constructor injects all necesary services
   * @param { AddUserComponent } dialogRef
   */
  constructor(
    public dialogRef: MatDialogRef<UserProfileComponent>,
    private fb: FormBuilder,
    private helperService: HelperService,
    public sharedDataService: SharedDataService,
    private commonService: CommonService,
    private accountSettingService: AccountSettingsService,
    private notificationService: NotificationService,
    private userManagementService: UserManagementService,
    private router: Router,
    private localizationService: LocalizationService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) private modalData: any
  ) {
    this.skipStepUserType = true;
    this.skipStepBuilding = false;
  }

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.parentRouteParams = this.modalData?.parentRouteParams;
    if (this.parentRouteParams) {
      this.groupTypeName = Utility.decodeFromBase64(
        this.parentRouteParams?.groupTypeName
      );
      this.userGroupId = Utility.decodeFromBase64(
        this.parentRouteParams?.userGroupId
      );
    }
    this.siteTimeZone = this.modalData?.siteTimeZone;
    this.createControls();
    if (this.modalData?.profileDetails) {
      if (this.modalData?.profileDetails.userAccess.temporaryAccess) {
        this.modalData.profileDetails.userAccess.temporaryAccess =
          this.expiryCheckWithCurrentUTC(
            this.modalData?.profileDetails.userAccess.temporaryAccess
          );
      }
      this.profileDetails = this.modalData?.profileDetails;
      this.ownProfile = this.modalData?.ownProfile;
      if (this.ownProfile) {
        this.commonService.setOwnProfile(true);
      } else {
        this.commonService.setOwnProfile(false);
      }
      this.userId = this.modalData?.userId;

      this.updateControl();
      this.profileDetailsRef?.setPhoneNumber();
      this.email = this.profileDetails?.email!;

      this.subscription = this.sharedDataService.currentData.subscribe(
        (sharedData) => {
          this.sharedData = sharedData;
          this.commonAccessControl =
            sharedData.selectedSite.commonAccessControl;
        }
      );
    }

    this.ownSubscription = this.commonService.ownProfileSubject.subscribe(
      (status: boolean) => {
        if (status) {
          this.getUserInfo();
          this.getMyLastActivity();
        } else {
          this.getUserOtherInfo();
          this.getOthersLastActivity();
        }
      }
    );
    this.getPhysicalCredential();
    this.accesspointCount = this.profileDetails?.accessPointCount;
    this.lockCount = this.profileDetails?.deviceCount;
    if (!this.commonAccessControl) {
      this.totalAccessCount =
        this.profileDetails?.userAccess.temporaryAccess.filter(
          (access) => access.entityType !== CONSTANTS.ACCESS_POINT
        ).length;
      this.totalAccessCount +=
        this.profileDetails?.userAccess.otherAccess.filter(
          (access) => access.entityType !== CONSTANTS.ACCESS_POINT
        ).length;
      this.totalAccessCount +=
        this.profileDetails?.userAccess.homeAccess.length;
    } else {
      this.totalAccessCount =
        this.profileDetails?.userAccess.temporaryAccess.length;
      this.totalAccessCount +=
        this.profileDetails?.userAccess.otherAccess.length;
      this.totalAccessCount +=
        this.profileDetails?.userAccess.homeAccess.length;
    }
  }

  /**
   * @description expiryCheckWithCurrentUTC return the temporary access after filtering expire access
   */
  private expiryCheckWithCurrentUTC(
    accessDetail: IAccessDetail[]
  ): IAccessDetail[] {
    return accessDetail?.filter(
      (access) => access.isExpired === false || access.isExpired === null
    );
  }
  private updateControl() {
    let userGroups = this.profileDetails.userGroups?.map(
      ({ userGroupName }) => userGroupName
    );
    this.formGroup.patchValue({
      userDetails: {
        name: `${this.profileDetails?.firstName} ${this.profileDetails?.lastName}`,
        firstName: this.profileDetails?.firstName,
        lastName: this.profileDetails?.lastName,
        phone: this.profileDetails?.phoneNumber,
        email: this.profileDetails?.email,
        userType: this.profileDetails?.userType,
        userGroups: userGroups ? userGroups : '',
        userAccess: this.totalAccessCount || 0,
        userActivity: this.userActivity,
        mobileCredential:
          String(this.profileDetails?.isMobileCredentialEnabled) === 'true'
            ? true
            : false,
        cardCredential: this.userCredentials?.length.toString(),
      },
    });
  }

  /**
   * @description #getUpdatedUserGroups is responsible for getting the  updated emitted data from the child component
   * and update the user groups list accordingly.
   * @param {updatedGroup}
   * @returns void
   */
  getUpdatedUserGroups(updatedGroup: any) {
    //push updated group to profileDetails.userGroups
    this.profileDetails.userGroups?.push(updatedGroup);
    this.userStepperChange(3);
  }
  private getUserInfo() {
    this.accountSettingService
      .getMyPersonalInfo(this.sharedData?.selectedSite?.siteId)
      .pipe(
        switchMap((userProfile: IUserProfile) => {
          this.profileDetails = userProfile;
          this.updateControl();

          if (!this.commonAccessControl) {
            return this.userManagementService.getUserGroupsBySite(
              this.sharedData?.selectedSite?.siteId
            );
          } else {
            return of([]);
          }
        })
      )
      .subscribe({
        next: (serverUserGroupList: IUserGroupDetails[]) => {
          const serverGroups = serverUserGroupList;
          var selectedGroupIds = new Set(
            this.profileDetails.userGroups?.map((item) => item.userGroupId)
          );

          this.userGroupList = serverGroups.map((item) => {
            return {
              ...item,
              active: selectedGroupIds.has(item.userGroupId),
            };
          });
        },
        error: (err: any) => {
          if (window.__dev__) console.log('getBuildingList', err);
        },
      });
  }

  getMyLastActivity(filterCriteria: IFilterCriteria | undefined = undefined) {
    this.userActivities = [];

    if (!filterCriteria) {
      filterCriteria = {
        eventCode: [],
        pagination: {
          size: 1, //we don't need this to load all of the items, yet, only get how many we have and set the cursor to the last one
        },
      };
    }

    this.ownProfile
      ? this.fetchOwnEventHistory(filterCriteria)
      : this.fetchEventHistoryByUser(filterCriteria);
  }

  /**
   * @description #fetchEventHistoryByUser functuion will call the getEventHistoryByUser
   *               in case of other profile of a user is clicked.
   * @param {filterCriteria}
   * @returns void
   */
  fetchEventHistoryByUser(filterCriteria: IFilterCriteria) {
    this.accountSettingService
      .getEventHistoryByUser(
        this.userId,
        filterCriteria,
        this.sharedData?.selectedSite?.siteId
      )
      .subscribe({
        next: (userActivities: Array<IUserActivity>) => {
          this.userActivities = userActivities;
          this.userActivity = -Infinity;
          this.userActivities?.forEach((activity: IUserActivity) => {
            const convertedDate = convertParseDateTime(
              activity?.isoTime,
              "yyyy-MM-dd'T'HH:mm:ss",
              't'
            );

            if (convertedDate && this.userActivity < convertedDate)
              this.userActivity = activity.isoTime;
          });
          if (String(this.userActivity) === String(-Infinity)) {
            this.userActivity = `${this.translate.instant('LAST_ACTVITIY')}`;
          } else {
            this.userActivity = activityParseDate(
              String(this.userActivity),
              "yyyy-MM-dd'T'HH:mm:ss",
              'MMM yyyy'
            );
            this.userActivity = `${this.translate.instant('LAST_ACTVITIY')} ${
              this.userActivity
            }`;
          }
          this.updateControl();
        },
      });
  }

  /**
   * @description #fetchOwnEventHistory functuion will call the getMyEventHistory
   *               in case of own profile is clicked.
   * @param {filterCriteria}
   * @returns void
   */
  fetchOwnEventHistory(filterCriteria: IFilterCriteria) {
    this.accountSettingService
      .getMyEventHistory(this.sharedData?.selectedSite?.siteId, filterCriteria)
      .subscribe({
        next: (userActivities: Array<IUserActivity>) => {
          this.userActivities = userActivities;
          this.userActivity = -Infinity;
          this.userActivities?.forEach((activity: IUserActivity) => {
            if (activity?.isoTime && this.userActivity < activity?.isoTime)
              this.userActivity = activity?.isoTime;
          });
          if (String(this.userActivity) === String(-Infinity)) {
            this.userActivity = `${this.translate.instant('LAST_ACTVITIY')}`;
          } else {
            this.userActivity = activityParseDate(
              extractDateTimeFromDateString(String(this.userActivity)),
              "yyyy-MM-dd'T'HH:mm:ss",
              'MMM yyyy'
            );
            this.userActivity = `${this.translate.instant('LAST_ACTVITIY')} ${
              this.userActivity
            }`;
          }
          this.updateControl();
        },
      });
  }

  private getOthersLastActivity() {
    this.userActivitiesNew = { events: [] };
    const filterCriteria: IFilterCriteria = {
      eventCode: [],
      pagination: {
        size: 1,
      },
    };
    this.accountSettingService
      .getEventHistoryByUserNew(
        this.userId,
        filterCriteria,
        this.sharedData?.selectedSite?.siteId
      )
      .subscribe({
        next: (userActivities: Activities) => {
          this.userActivitiesNew = userActivities;
          this.userActivity = -Infinity;
          this.userActivitiesNew?.events?.forEach(
            (activity: IActivityEvents) => {
              if (
                (activity?.isoTime && this.userActivity === -Infinity) ||
                (activity?.isoTime && this.userActivity < activity?.isoTime)
              )
                this.userActivity = activity?.isoTime;
            }
          );
          this.userActivity = activityParseDate(
            extractDateTimeFromDateString(String(this.userActivity)),
            "yyyy-MM-dd'T'HH:mm:ss",
            'MMM yyyy'
          );
          this.userActivity = `${this.translate.instant('LAST_ACTVITIY')} ${
            this.userActivity
          }`;
          this.updateControl();
        },
      });
  }

  private getUserOtherInfo() {
    this.accountSettingService
      .getSpecficUserProfileInfo(
        this.sharedData?.selectedSite?.siteId,
        this.userId
      )
      .pipe(
        switchMap((userProfile: IUserProfile) => {
          this.profileDetails = userProfile;
          if (this.profileDetails.userAccess.temporaryAccess) {
            this.profileDetails.userAccess.temporaryAccess =
              this.expiryCheckWithCurrentUTC(
                this.profileDetails.userAccess.temporaryAccess
              );
          }
          this.updateControl();

          if (!this.commonAccessControl) {
            return this.userManagementService.getUserGroupsBySite(
              this.sharedData?.selectedSite?.siteId
            );
          } else {
            return of([]);
          }
        })
      )
      .subscribe({
        next: (serverUserGroupList: IUserGroupDetails[]) => {
          const serverGroups = serverUserGroupList;
          var selectedGroupIds = new Set(
            this.profileDetails.userGroups?.map((item) => item.userGroupId)
          );

          this.userGroupList = serverGroups.map((item) => {
            return {
              ...item,
              active: selectedGroupIds.has(item.userGroupId),
            };
          });
        },
        error: (err: any) => {
          if (window.__dev__) console.log('getBuildingList', err);
        },
      });
  }

  /**
   * @description getPhysicalCredential function will call the getUserCardsList API
   * @returns void
   */
  getPhysicalCredential(): void {
    if (this.ownProfile) {
      this.accountSettingService
        .getMyCardsList(
          this.formGroup?.controls.userDetails.value.email,
          this.sharedData?.selectedSite?.siteId
        )
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.userCredentials = res;
              this.updateControl();
            }
          },
        });
    } else {
      this.accountSettingService
        .getUserCardsList(
          this.formGroup?.controls.userDetails.value.email,
          this.sharedData?.selectedSite?.siteId
        )
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.userCredentials = res;
              this.updateControl();
            }
          },
        });
    }
  }
  /**
   * @description Create all child component into parents
   * @returns void
   */
  createControls(): void {
    this.formGroup = this.fb.group({
      userDetails: this.fb.group({
        name: [''],
        firstName: [''],
        lastName: [''],
        phone: [''],
        email: [''],
        userType: [''],
        userGroups: [''],
        userAccess: [''],
        userActivity: [''],
        mobileCredential: [],
        cardCredential: [],
      }),
      accessTime: this.fb.group(
        {
          startTime: [''],
          expireTime: [''],
          repeat: [false],
        },
        {
          validator: [
            MFValidators.startTimeEndTime('startTime', 'expireTime'),
            MFValidators.startTimeSiteZoneValidator(
              'startTime',
              this.siteTimeZone!
            ),
            MFValidators.siteZoneValidator('expireTime', this.siteTimeZone!),
          ],
        }
      ),
      shareAccessTime: this.fb.group(
        {
          startTime: [''],
          expireTime: [''],
          repeat: [false],
        },
        {
          validator: [
            MFValidators.startTimeEndTime('startTime', 'expireTime'),
            MFValidators.startTimeSiteZoneValidator(
              'startTime',
              this.siteTimeZone!
            ),
            MFValidators.siteZoneValidator('expireTime', this.siteTimeZone!),
          ],
        }
      ),
    });
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef.close();
  }

  /**
   * @description setPhoneNumber function validates phone number and apply masking on the number.
   */
  setPhoneNumber(phone: string): void {
    this.helperService.validatePhoneFormat(phone).subscribe(
      ({
        phoneNumber,
        region,
        code,
      }: {
        phoneNumber: string;
        region: string;
        code: string;
      }) => {
        this.code = code;
      },
      (err: string) => {
        if (window.__dev__) console.log('validatePhoneFormat', err);
        this.code = '';
      }
    );
  }

  removeUserAccessHandler(accessIds: string[]): void {
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmRemoveDialogComponent,
      {
        title: this.translate.instant('REMOVE_ACCESS'),
        bodyText: this.translate.instant(
          'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_ACCESS_FROM_USER'
        ),
        showCloseBtn: true,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.accountSettingService.removeUserAccess(accessIds).subscribe({
          next: (res: any) => {
            if (this.profileDetails.userAccess.temporaryAccess) {
              this.expiryCheckWithCurrentUTC(
                this.profileDetails.userAccess.temporaryAccess
              );
            }

            let userAccess = this.profileDetails.userAccess;
            for (let accessId of accessIds) {
              let homeAccess: IAccessDetail[] = userAccess?.homeAccess?.filter(
                (record: any) => record?.accessId !== accessId
              );
              let otherAccess: IAccessDetail[] =
                userAccess?.otherAccess?.filter(
                  (record: any) => record?.accessId !== accessId
                );
              let temporaryAccess: IAccessDetail[] =
                userAccess?.temporaryAccess?.filter(
                  (record: any) => record?.accessId !== accessId
                );
              userAccess = {
                homeAccess,
                otherAccess,
                temporaryAccess,
              };
            }
            this.profileDetails = Object.assign({}, this.profileDetails, {
              userAccess: userAccess,
            });
            this.formGroup.patchValue({
              userDetails: {
                userAccess: this.totalAccessCount - accessIds.length,
              },
            });
            this.notificationService.showSuccess(
              this.commonService.stringInterPolation(
                this.translate.instant('SUCCESSFULLY_DELETED'),
                this.translate.instant('ACCESS')
              )
            );
            this.stepper = 9;
          },
          error: (error: Error) => {
            this.notificationService.showError(error?.message);
          },
        });
        this.accessIds = [];
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.ownSubscription?.unsubscribe();
    this.userListsubscription?.unsubscribe();
  }

  onRemoveUserFromDeletion(): void {
    const isCardActive = this.userCredentials?.some(
      (card: ICardCredentials) => card?.cardStatus === 'ACTIVE'
    );

    const dialogInstance = this.helperService.openModalDialog(
      PhysicalCredentialRemovedComponent,
      {
        userDetail: {
          title: this.translate.instant('USER_PROFILE'),
          userName: `${this.profileDetails?.firstName} ${this.profileDetails?.lastName}`,
          isCardActive,
          userId: this.userId,
          siteId: this.sharedData?.selectedSite?.siteId,
        },
        enableBackOperation: false,
        stepper: isCardActive ? 1 : 0,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );

    dialogInstance
      .afterClosed()
      .pipe(
        switchMap((res: any) => {
          const currentUrl = this.router.url;
          this.flowType = CONSTANTS.REMOVE_USER;
          this.dialogRef?.close(this.flowType);

          if (currentUrl?.includes(CONSTANTS.USER_DASHBOARD)) {
            const criteria = {
              size: 10000,
              searchText: '',
              userGroupId: this.userGroupId,
            };

            this.router.navigate([
              CONSTANTS.USER_DASHBOARD,
              Utility.encodeToBase64(this.groupTypeName),
              Utility.encodeToBase64(this.userGroupId),
            ]);

            return this.userManagementService.getDashboardUsers(criteria);
          } else if (currentUrl?.includes(CONSTANTS.USERS)) {
            this.userManagementService.setTriggerRerender(true);
            this.router.navigate(['/users']);
            return this.userManagementService.getAllUsers(
              this.sharedData?.selectedSite?.siteId,
              CONSTANTS.GET_USERS_BY_SITES_OPERATION_VIEW,
              40,
              undefined,
              false,
              true
            );
          }

          return of();
        })
      )
      .subscribe((result: boolean) => {
        if (result) {
          this.router.navigate(['/users']);
          this.dialogRef?.close();
          this.userManagementService.scrollToTop();
          this.userManagementService
            .getAllUsers(
              this.sharedData?.selectedSite?.siteId,
              CONSTANTS.GET_USERS_BY_SITES_OPERATION_VIEW,
              40,
              undefined,
              false,
              true
            )
            .subscribe();
        }
      });
  }

  onRejectDeletion(): void {
    this.userManagementService
      .rejectAccountDeletionRequest(
        this.userId,
        this.sharedData?.selectedSite?.siteId
      )
      .subscribe({
        next: () => {
          const filterUserParam: FilterUserParameter[] | undefined =
            this.sharedDataService.filterUser;
          const searchedWord: string =
            this.sharedDataService.searchFilterUserWord;

          if (this.router.url?.includes(CONSTANTS.USER_DASHBOARD)) {
            const criteria = {
              size: 10000,
              searchText: '',
              userGroupId: this.userGroupId,
            };
            this.userManagementService.getDashboardUsers(criteria).subscribe();
          } else if (this.router.url?.includes(CONSTANTS.USERS)) {
            const siteId = this.sharedData?.selectedSite?.siteId;

            (filterUserParam
              ? this.userManagementService.getUsersBySite(
                  siteId,
                  searchedWord,
                  CONSTANTS.GET_USERS_BY_SITES_OPERATION_VIEW,
                  false,
                  this.pageSize,
                  false,
                  filterUserParam,
                  undefined,
                  true
                )
              : this.userManagementService.getAllUsers(
                  siteId,
                  CONSTANTS.GET_USERS_BY_SITES_OPERATION_VIEW,
                  this.pageSize,
                  undefined,
                  false,
                  true,
                  false,
                  searchedWord
                )
            ).subscribe();
          }
          this.userManagementService.setTriggerRerender(true);
          this.stepper = 14;
        },
        error: (error: Error) => {
          this.notificationService.showError(error?.message);
        },
      });
  }

  /* 
    this method returns selected user group for user profile flow
    from user group component 
   */
  userGroupChange(selectedGroup: any) {
    this.profileSelectedGroup = selectedGroup;
  }

  /**
   * this method change user stepper and add group flag to true
   * for executing user group flow for user profile
   */
  userStepperChange(step: number) {
    this.stepper = step === 3 ? step : 4;
    this.addGroupFlag = true;
  }

  submitToUserProfile(userDetails: any) {
    userDetails.userGroupId = this.profileSelectedGroup?.userGroupId;
    userDetails.siteId = this.sharedData?.selectedSite?.siteId;
    userDetails.users = {
      id: userDetails?.userId,
      accessLevel: AccessLevelRequest['Resident_Admin'],
    };
    delete userDetails[this.userId];
    this.accountSettingService
      .addUserGroupsToUserAccess(userDetails)
      .subscribe({
        next: (res: any) => {
          this.notificationService.showSuccess(
            this.commonService.stringInterPolation(
              this.translate.instant('SUCCESSFULLY_ADDED'),
              this.translate.instant('USER_GROUP')
            )
          );
          let existingGroups = this.profileDetails?.userGroups;
          existingGroups?.push({
            ...userDetails,
            ...this.profileSelectedGroup,
          });
          this.profileDetails.userGroups = existingGroups;
          this.profileGroupsRef?.updateGroups();
          this.stepper = 3;
          this.updateControl();
        },
        error: (error: Error) => {
          this.notificationService.showError(error.message);
        },
      });
  }

  submitToUserProfileEmitter(userDetails: IShareAccess) {
    this.accountSettingService.updateUserAccess(userDetails).subscribe({
      next: (res: any) => {
        this.notificationService.showSuccess(
          this.commonService.stringInterPolation(
            this.translate.instant('UPDATED_SUCCESSFULLY'),
            this.translate.instant('USER_ACCESS')
          )
        );

        this.stepper = 9;
      },
      error: (error: Error) => {
        this.notificationService.showError(error.message);
      },
    });
  }

  formReset() {}

  userGroupListChange(selectedUserGroups: IUserGroupDetails[]) {
    const selectedGroups =
      selectedUserGroups?.filter(
        (group) => group.active && group.userGroupId
      ) || [];
    const deleteUserGroupId = this.profileDetails?.userGroups?.filter(
      (userGroups) =>
        !selectedGroups.some(
          (selectedGroup) =>
            selectedGroup.userGroupId === userGroups.userGroupId
        )
    );
    const deletedGroupId = deleteUserGroupId?.map((group) => group.userGroupId);

    const newSelectedGroupId = selectedGroups.filter(
      (selectedGroup) =>
        !this.profileDetails?.userGroups?.some(
          (group) => group.userGroupId === selectedGroup.userGroupId
        )
    );

    let userDetail: IShareAccess | any = {};
    const observables = [];
    if (deletedGroupId!.length > 0) {
      observables.push(
        this.accountSettingService.deleteGroup(
          <string[]>deletedGroupId,
          this.profileDetails?.email as string
        )
      );
    }
    if (newSelectedGroupId!.length > 0) {
      userDetail.existingUserId = this.profileDetails.email;
      userDetail.firstName = this.profileDetails.firstName;
      userDetail.lastName = this.profileDetails.lastName;
      userDetail.phone = this.profileDetails.phoneNumber;
      userDetail.siteId = this.sharedData.selectedSite.siteId;
      userDetail.userType =
        this.profileDetails.userTypeId === 7
          ? 6
          : this.profileDetails.userTypeId;
      userDetail.startTime = CONSTANTS.NOW;
      userDetail.entities = [];
      userDetail.userGroups = newSelectedGroupId.map(
        (newSelecteedGroup) => newSelecteedGroup.userGroupId
      );
      observables.push(this.userManagementService.shareAccess(userDetail));
    }

    forkJoin(observables)
      .pipe(
        catchError((error) => {
          if (window.__dev__)
            console.log('Error deleteGroup and ShareAccess:', error);
          // Handle errors if needed
          return of([]); // Return an empty array or another default value
        })
      )
      .subscribe(([groupData, shareAccessData]) => {
        if (deletedGroupId!.length > 0) {
          this.profileDetails.userGroups = (
            this.profileDetails?.userGroups || []
          ).filter(
            (userGroup) => !deletedGroupId!.includes(userGroup.userGroupId!)
          );
          this.userGroupList = this.userGroupList.map((group) => ({
            ...group,
            active: deletedGroupId!.includes(group.userGroupId!)
              ? false
              : group.active,
          }));
        }

        if (newSelectedGroupId!.length > 0) {
          newSelectedGroupId;
          selectedGroups;

          this.profileDetails = {
            ...this.profileDetails,
            userGroups: [
              ...(this.profileDetails?.userGroups || []),
              ...(newSelectedGroupId as IuserGroup[]),
            ],
          };

          this.userGroupList = this.userGroupList.map((group) => ({
            ...group,
            active: userDetail.userGroups!.includes(group.userGroupId!)
              ? true
              : group.active,
          }));
        }
        this.updateControl();
        console.log('deleteGroup: successful deletion');
        // It will decided redirect group listing or stay in same page if user group contain exisiting GroupId
        this.userNotHaveExistingGroup = !this.userGroupList.some(
          (userGroup) =>
            userGroup.userGroupId === this.userGroupId && userGroup.active
        );
      });
  }
}
